import { useEffectOnce } from 'hook/useEffectOnce'
import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { InferenceStore } from 'store/inference/InferenceStore'
import { Size } from 'type/size'

export class SizesBannerStore {
  readonly inference: InferenceStore
  readonly sizes: Size[]

  constructor(inference: InferenceStore, sizes: Size[]) {
    this.inference = inference
    this.sizes = sizes
    makeAutoObservable(this)
  }
}

export const sizes_banner = mx.ref<SizesBannerStore>()

export function useSizesBanner() {
  useEffectOnce(() => {
    return () => sizes_banner.close()
  })
}

export function openSizesBanner(inference: InferenceStore, sizes: Size[]) {
  sizes_banner.open(new SizesBannerStore(inference, sizes))
}
